import React from 'react';

const WardrobeLayoutPreview = ({ layout, totalWidth, height = 9.5 }) => {
  if (!layout || layout.length === 0) return null;

  const totalBoxWidth = layout.reduce((sum, b) => sum + b.width, 0);

  return (
    <div data-testid="wardrobe-layout-preview" className="w-full">
      <div className="flex items-end w-full border-2 border-stone-400 bg-stone-50 overflow-hidden"
           style={{ height: '200px' }}>
        {layout.map((box, idx) => {
          const widthPct = (box.width / totalBoxWidth) * 100;
          return (
            <div
              key={idx}
              data-testid={`layout-box-${idx + 1}`}
              className="h-full flex flex-col border-r border-stone-400 last:border-r-0 relative"
              style={{ width: `${widthPct}%` }}
            >
              <div className="text-[10px] text-center py-1 bg-stone-200 text-stone-600 font-medium tracking-wide border-b border-stone-300">
                Box {idx + 1}
              </div>

              <div className="flex flex-1 w-full">
                {Array.from({ length: box.shutters }).map((_, si) => (
                  <div
                    key={si}
                    data-testid={`box-${idx + 1}-shutter-${si + 1}`}
                    className="flex-1 border-r border-stone-300 last:border-r-0 flex items-center justify-center relative"
                    style={{
                      background: box.shutterType === 'sliding'
                        ? 'linear-gradient(135deg, #e8e4df 0%, #d4cfc8 100%)'
                        : 'linear-gradient(135deg, #f5f3f0 0%, #ece9e4 100%)',
                    }}
                  >
                    {box.shutterType === 'hinged' && (
                      <div className="absolute top-2 right-0.5 flex flex-col gap-6">
                        <div className="w-1 h-3 bg-stone-400 rounded-sm" />
                        <div className="w-1 h-3 bg-stone-400 rounded-sm" />
                      </div>
                    )}
                    <span className="text-[9px] text-stone-400 font-medium rotate-90 select-none">
                      {box.shutterType === 'sliding' ? 'SLIDE' : 'DOOR'}
                    </span>
                  </div>
                ))}
              </div>

              <div className="text-[10px] text-center py-1 bg-stone-200 text-stone-500 font-mono border-t border-stone-300">
                {box.width.toFixed(2)} ft
              </div>
            </div>
          );
        })}
      </div>

      <div className="flex justify-between items-center mt-2 text-xs text-stone-500">
        <span className="font-mono">Total: {totalWidth || totalBoxWidth.toFixed(2)} ft wide</span>
        <span className="font-mono">{height} ft tall</span>
        <span>
          {layout.length} box{layout.length > 1 ? 'es' : ''} |{' '}
          {layout.reduce((sum, b) => sum + b.shutters, 0)} shutters
        </span>
      </div>
    </div>
  );
};

export default WardrobeLayoutPreview;
